import React from 'react';
import { ResponsiveRatingLineChartSwitch } from './ResponsiveRatingLineChart';
export var CHART_CONTROL_TYPES = {
    RATING_SCALE_GROUP_ANSWERS: 'RATING_SCALE_GROUP_ANSWERS'
};
export var CustomControlLegend = function(param) {
    var type = param.type, controlProps = param.controlProps;
    if (type === CHART_CONTROL_TYPES.RATING_SCALE_GROUP_ANSWERS) {
        return /*#__PURE__*/ React.createElement(ResponsiveRatingLineChartSwitch, {
            isChecked: controlProps.isChecked,
            onChange: controlProps.onChange,
            answersCount: controlProps.answersCount
        });
    }
    return null;
};
